// Module 27's dashboard-widget registration — 09's registry inversion (contract 09 §8): the
// feature REGISTERS a lazy loader for the kind it owns; 09 imports nothing from here. Called from
// `app/bootstrap.ts` beside the other feature registrars, before the router mounts.
//
// The loader also pulls this feature's (and 08's) message bundles: a dashboard is the one surface
// that renders the panel without the route's `beforeEnter` having run, so the copy must ride the
// same chunk fetch.

import { registerCommerceMessages } from '../i18n'

import { registerDashboardWidget } from '@/features/dashboards'
import { registerReportMessages } from '@/features/reports'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

export function registerCommerceWidgets(): void {
  registerDashboardWidget('performance_overview', async () => {
    const locale = activeLocale()
    const [component] = await Promise.all([
      import('../components/budget/PerformanceOverviewPanel.vue'),
      registerReportMessages(locale),
      registerCommerceMessages(locale),
    ])
    return component
  })
}
